import React from 'react';
import { Box, Chip, Tooltip } from '@mui/material';
import ScheduleIcon from '@mui/icons-material/ScheduleOutlined';

import { colors } from '../../../../theme/tokens';

/**
 * Small visual marker for users whose `first_login_ts` is still NULL — i.e.
 * they've been invited (row exists in `config.app_user`) but haven't
 * logged in yet, so we don't have their Auth0 identity bound to the row.
 */
const PendingFirstLoginChip: React.FC = () => (
  <Tooltip title="User has been invited but has not logged in yet.">
    <Chip
      size="small"
      icon={<ScheduleIcon sx={{ fontSize: 12 }} />}
      label="Pending first login"
      sx={{
        fontSize: 10,
        fontWeight: 700,
        fontFamily: 'Manrope, sans-serif',
        letterSpacing: '0.3px',
        textTransform: 'uppercase',
        backgroundColor: colors.warningBg,
        color: colors.warningText,
        border: `1px solid ${colors.warningBorder}`,
        '& .MuiChip-icon': { color: colors.warningIcon, ml: 0.5 },
        height: 20,
      }}
    />
  </Tooltip>
);

export default PendingFirstLoginChip;
